import { useHistory } from 'react-router-dom';
import {
  StyledButton,
  IconWrapper,
  IconWrapperRight,
  StyledLinkButton,
  StyledDescription
} from './style';
import { Icon } from '../icon';

export const Button = (props) => {
  let history = useHistory();

  let attrs = { ...props };

  let classes = [];
  if(attrs.className) classes.push(attrs.className);
  if(attrs.size) classes.push(`button-${attrs.size}`);
  if(attrs.buttonStyle) classes.push(`button-${attrs.buttonStyle}`);
  if(attrs.align) classes.push(`button-${attrs.align}`);

  attrs.type = attrs.type || 'button';

  if(attrs.href) {
    attrs.onClick = () => {
      history.push(attrs.href);
    }
  }

  let icon;
  if(attrs.icon) {
    let Wrapper = attrs.align === 'right' ? IconWrapperRight : IconWrapper;

    icon = <Wrapper className="wrapper">
      <Icon icon={attrs.icon} />
    </Wrapper>
  }

  let description;
  if(attrs.description) {
    description = <StyledDescription className="button-description">
      {attrs.description}
    </StyledDescription>;
  }

  return (
    <StyledButton className={classes.join(' ')} {...attrs}>
      {attrs.children}
      {icon}
      {description}
    </StyledButton>
  )
}

export const LinkButton = (props) => {
  let history = useHistory();
  let attrs = { ...props };

  let classes = [];
  if(attrs.className) classes.push(attrs.className);

  attrs.type = attrs.type || 'button';

  if(attrs.href) {
    attrs.onClick = () => {
      history.push(attrs.href);
    }
  }
  return (
    <StyledLinkButton className={classes.join(' ')} {...attrs}>
      {attrs.children}
    </StyledLinkButton>
  )
}
